import { getSearchParam } from "@/utils";
import "dayjs/locale/en";
// 全球英语
const EN_GL_LANGS = new Set(["en-gb"]);
export function is_en_gl_link() {
  const lan = getSearchParam("lan") || "";
  return EN_GL_LANGS.has(lan);
}
// 法语
const FR_LANGS = new Set(["fr", "fr-fr"]);
const FR_LINKS = new Set(["fr-mils.comfortweather.com"]);
export function is_fr_link() {
  const lan = getSearchParam("lan") || "";
  const { hostName } = useHostName();
  if (lan) {
    return FR_LANGS.has(lan);
  }
  return FR_LINKS.has(hostName);
}
// 西班牙语(拉美)
const ES_LANGS = new Set(["es-419", "es-co", "es-es", "es-mx"]);
export function is_es_mx_link() {
  const lan = getSearchParam("lan") || "";
  return ES_LANGS.has(lan);
}
// 土耳其语
const TR_LANGS = new Set(["tr", "tr-tr"]);
const TR_LINKS = new Set(["tr-mils.comfortweather.com"]);
export function is_tr_link() {
  const lan = getSearchParam("lan") || "";
  const { hostName } = useHostName();
  if (lan) {
    return TR_LANGS.has(lan);
  }
  return TR_LINKS.has(hostName);
}
// 德语
const DE_LANGS = new Set(["de", "de-de"]);
const DE_LINKS = new Set(["ger-mils.comfortweather.com"]);
export function is_de_link() {
  const lan = getSearchParam("lan") || "";
  const { hostName } = useHostName();
  if (lan) {
    return DE_LANGS.has(lan);
  }
  return DE_LINKS.has(hostName);
}
